The date & time the HTTP request occurred.

This field has weak ordering guarantees, so it should not be used as a pagination argument.
